import { render } from "./ShowCasesGroup2.vue?vue&type=template&id=7cc15f50"
import script from "./ShowCasesGroup2.vue?vue&type=script&lang=js"
export * from "./ShowCasesGroup2.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__